const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/partners.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, notFound } from "@tanstack/react-router";
import { requireMember } from "@/routes/_app/guards";
import { client } from "@/utils/orpc.client";
export const Route = createFileRoute("/_app/partners")({
  beforeLoad: async ({
    context: {
      queryClient
    },
    location
  }) => {
    await requireMember({
      queryClient,
      location
    });
    const partnerAccess = await client.partners.getAreaAccess();
    if (!partnerAccess.allowed) throw notFound();
    return {
      partnerAccess
    };
  },
  head: () => ({
    meta: [{
      name: "robots",
      content: "noindex, nofollow"
    }]
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});